module.exports = __webpack_public_path__ + "img/vi.89fc37e9.png";